import script from "./ArgonHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonHeader.vue?vue&type=script&setup=true&lang=js"

import "./ArgonHeader.vue?vue&type=style&index=0&id=3a43a6bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a43a6bc"]])

export default __exports__